module.exports = __webpack_public_path__ + "img/error-img.54952fbd.svg";